import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'
import { MapAssets } from './MapAssets'
import { useTranslation } from 'react-i18next'

const boxStyle = {
  minHeight: 400,
  width: '100%',
}

const AssetsMapModal = ({open, closeModal, assetList, isLoading}) => {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onClose={closeModal} maxWidth="lg" fullWidth>
      <DialogTitle>
        {t('component.mapAsset.modal.assetsMap')}
        <IconButton
          aria-label="close"
          onClick={closeModal}
          sx={{
            position: 'absolute',
            right: '8px',
            top: '8px',
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent >
        {isLoading ?
          <Box
            sx={boxStyle}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress />
          </Box>
        :
          <MapAssets assetList={assetList} style={boxStyle}/>
        }
      </DialogContent>
    </Dialog>
  )
}

export default AssetsMapModal